import { declOfNum } from '../../../../../helpers/dspx-utils';
import { allowedDateFormats, isValid } from './dateTime';
import { toNum } from './transformValues';

const createColName = (label) => (label ? `Колонка «${label}»` : 'Колонка');
const createRequiredMsg = (name) => `${name} - обязательна для заполнения`;

export const getTypeValidator =
  ({ ids = [], label, required = false }) =>
  (_rule, value, callback) => {
    const name = createColName(label);

    if (!value) {
      return callback(required ? createRequiredMsg(name) : undefined);
    }

    if (isNaN(value)) {
      return callback(`${name} - значение должно быть числом`);
    }

    const message = !ids.includes(value)
      ? `${name} содержит недопустимое значение. Допустимые значения: ${ids.join(
          ', '
        )}`
      : undefined;

    callback(message);
  };

const getTextValidator =
  ({ label, required = false, maxLength, pattern }) =>
  (_rule, value, callback) => {
    const name = createColName(label);

    if (!value) {
      return callback(required ? createRequiredMsg(name) : undefined);
    }

    if (maxLength && value.length > maxLength) {
      const maxText = `${maxLength} ${declOfNum(maxLength, [
        'символ',
        'символа',
        'символов',
      ])}`;

      return callback(
        `${name} - значение не может содержать больше ${maxText}. Сейчас - ${value.length}`
      );
    }

    if (pattern && !pattern.test(value)) {
      return callback(`${name} содержит некорректные символы`);
    }

    callback();
  };

const getDateValidator =
  ({ label, required = false }) =>
  (_rule, value, callback) => {
    const name = createColName(label);

    if (!value) {
      return callback(required ? createRequiredMsg(name) : undefined);
    }

    if (!isValid(value)) {
      return callback(
        `${name} - неверный формат даты. Допустимые форматы - ${allowedDateFormats.string}`
      );
    }

    callback();
  };

export const createTypeRule = (params) => ({
  validator: getTypeValidator(params),
  transform: toNum,
});

export const createTextRule = (params) => ({
  validator: getTextValidator(params),
});

export const createPhoneRule = (required = false) => ({
  required,
  pattern: /^\d{10}$/,
  message: 'Номер телефона должен состоять из 10 цифр',
});

export const createNumberRule = ({ required = false, label }) => ({
  type: 'number',
  required,
  message: `${createColName(label)} - значение должно быть числом`,
  transform: toNum,
});

export const createIntegerRule = ({ required, label }) => ({
  type: 'integer',
  required,
  message: `${createColName(label)} - значение должно быть целым числом`,
  transform: toNum,
});

export const createEmailRule = (required = false) => ({
  required,
  type: 'email',
  message: 'Эл. почта должна быть корректной',
});

export const createDateRule = (params) => ({
  validator: getDateValidator(params),
});
